import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { gpColors } from "../../../constants/colors";
import SideDrawer from "../Drawer";
import { getCookie } from "../../../Functions";
import CryptoAES from "crypto-js/aes";
import CryptoENC from "crypto-js/enc-utf8";
import AddProductValMOdal from "../AddProductValMOdal";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import { routes } from "../../../constants/routes";
import Cookies from "js-cookie";
import api from "../../Interceptors/axiosInstance";

const useStyles = makeStyles((theme) => ({
  roots: {
    display: "flex",
    height: "auto",
    backgroundColor: "#EAE4E8",
  },
  content: {
    width: "100%",
    height: "auto",
    flexGrow: 1,
    paddingTop: "84px",
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  title: {
    fontSize: "20px",
    fontWeight: 600,
    paddingBottom: 20,
  },
  root: {
    minHeight: "280px",
    marginTop: "20px",
  },
  deactiveLink: {
    color: "red",
    cursor: "pointer",
    textDecoration: "none",
    fontSize: "0.875rem",
    fontWeight: "bold",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  exportButton: {
    backgroundColor: gpColors.logoBrown,
    color: "#fff",
    marginBottom: "12px",
    width: "15%",
    "&.MuiButtonBase-root": {
      "&:hover": { backgroundColor: gpColors.logoBrown },
    },
    [theme.breakpoints.down("sd")]: {
      width: "60%",
    },
  },
}));

const ContainerDetails = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const classes = useStyles();
  const [userData, setUserData] = useState({});
  const [loader, setLoader] = useState(false);
  const [containerData, setContainerData] = useState([]);
  const [token, setToken] = useState();
  const [btnLoader, setBtnLoader] = useState(false);

  const filteredData = Array.isArray(containerData)
    ? containerData.filter(
        (item) =>
          item.containerId?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.invoiceNo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.scanDate?.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : [];

  //   columns for table
  const columns = [
    {
      name: "Date",
      selector: (row) => row.scanDate || "NA",
      ortable: true,
      center: true,
    },
    {
      name: "Invoice No",
      selector: (row) => row.invoiceNo || "NA",
      sortable: true,
      center: true,
    },
    {
      name: "Container ID",
      selector: (row) => row.containerId || "NA",
      ortable: true,
      center: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <span
          style={{ color: "#1976d2", cursor: "pointer", fontWeight: "bold" }}
          onClick={() =>
            navigate(routes.CONTAINER_PARTS, {
              state: { containerId: row.containerId, cId: row.cId },
            })
          }
        >
          View
        </span>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      center: true,
    },
  ];

  const [alert, setAlert] = useState({
    alertStatus: false,
    alertMessage: "",
    alertColor: "",
  });

  const [validationModal, setValidationModal] = useState(false);
  function closeValidationModal() {
    setValidationModal(false);
  }
  // Alert box close
  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({
      ...alert,
      alertStatus: false,
      alertColor: "",
      alertMessage: "",
    });
  };

  //Getting cookies
  // const getLoginInfoData = () => {
  //   const getValue = getCookie("guardPlus_user");
  //   if (getValue !== null) {
  //     const decryptedValue = CryptoAES.decrypt(getValue, "secretKey");
  //     const userVal = JSON.parse(decryptedValue.toString(CryptoENC));
  //     setUserData(userVal);
  //     setToken(userVal.loginInfo.data.jwt);
  //   }
  // };
  // const sessionUsername = Cookies.get("userName");
    const sessionUsername = sessionStorage.getItem("userName");
  const getLoginInfoData = () => {
    setUserData({ username: sessionUsername });
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    getLoginInfoData();
  }, []);

  useEffect(() => {
    getAllContainers();
  }, [userData]);

  const getAllContainers = async () => {
    setLoader(true);
    try {
      // const resp = await fetch(
      //   `${process.env.REACT_APP_API_ENDPOINT}/getAllContainerIds`,
      //   {
      //     method: "GET",
      //     headers: {
      //       // "ngrok-skip-browser-warning": "true",
      //       Authorization: `Token ${token}`,
      //     },
      //   }
      // );
      const resp = await api.get("/getAllContainerIds");
      const data = await resp.data;
      if (data.result === "success") {
        setContainerData(data.resultData);
      }
      setLoader(false);
    } catch (e) {
      console.log("Container List Error--------------", e);
      setLoader(false);
    }
  };

  const exportContainers = async () => {
    setBtnLoader(true);
    try {
      // const response = await fetch(
      //   `${process.env.REACT_APP_API_ENDPOINT}/exportAllContainersData`,
      //   {
      //     method: "GET",
      //     headers: {
      //       // "ngrok-skip-browser-warning": "true",
      //       Authorization: `Token ${token}`,
      //     },
      //   }
      // );
      // if (response.ok) {
      //   const blob = await response.blob();
      //   const url = window.URL.createObjectURL(blob);
      //   const a = document.createElement("a");
      //   a.href = url;
      //   const dateOnly = new Date().toISOString().split("T")[0];
      //   a.download = `containerData_${dateOnly}.xlsx`;
      //   a.style.display = "none";
      //   document.body.appendChild(a);
      //   a.click();
      //   a.remove();
      //   window.URL.revokeObjectURL(url);
      // } else if (response.status === 404) {
      //   setAlert({
      //     ...alert,
      //     alertStatus: true,
      //     alertColor: "red",
      //     alertMessage: "No data found to generate Excel file.",
      //   });
      // } else {
      //   setAlert({
      //     ...alert,
      //     alertStatus: true,
      //     alertColor: "red",
      //     alertMessage: "An error occurred while exporting the data.",
      //   });
      // }
      const response = await api.get("exportAllContainersData", {
        responseType: "blob",
      });

      if (response && response.status === 200) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        const dateOnly = new Date().toISOString().split("T")[0];
        a.download = `ContainerData${dateOnly}.xlsx`;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        a.remove();

        window.URL.revokeObjectURL(url);
      } else if (response.status === 404) {
        setAlert({
          ...alert,
          alertStatus: true,
          alertColor: "red",
          alertMessage: "No data found to generate Excel file.",
        });
      } else {
        setAlert({
          ...alert,
          alertStatus: true,
          alertColor: "red",
          alertMessage: "An error occurred while exporting the data.",
        });
      }
    } catch (error) {
      console.error("Error exporting containers:", error);
      setAlert({
        ...alert,
        alertStatus: true,
        alertColor: "red",
        alertMessage: "An error occurred while exporting the data.",
      });
    } finally {
      setBtnLoader(false);
    }
  };

  return (
    <Box className={classes.roots}>
      <SideDrawer tabName="containerDetails"/>
      <main className={classes.content}>
        <Box style={{ display: "flex", justifyContent: "space-between" }}>
          <Typography className={classes.title}>Container Details</Typography>
          <Button className={classes.exportButton} onClick={exportContainers}>
            {btnLoader ? <CircularProgress size={25} /> : "Export"}
          </Button>
        </Box>
        <Divider />
        <Card className={classes.root}>
          <CardContent>
            <div style={{ padding: "20px" }}>
              {/* Search bar */}
              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    marginBottom: "10px",
                    padding: "10px",
                    width: "300px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                  }}
                />
              </Box>
              {/* DataTable */}
              <div style={{ overflow: "hidden" }}>
                <DataTable
                  columns={columns}
                  data={filteredData}
                  progressPending={loader}
                  progressComponent={
                    <CircularProgress color="inherit" size={25} />
                  }
                  noDataComponent={
                    <div
                      style={{
                        color: "#F22F46",
                        fontWeight: 600,
                        marginTop: "20px",
                      }}
                    >
                      Data Not Exist
                    </div>
                  }
                  pagination
                  paginationRowsPerPageOptions={[5, 10, 15, 20, 50, 100]}
                  highlightOnHover
                  striped
                  responsive
                  persistTableHead
                  customStyles={{
                    headCells: {
                      style: {
                        backgroundColor: gpColors.logoGray,
                        color: "#fff",
                        fontWeight: "bold",
                        justifyContent: "center",
                      },
                    },
                    rows: {
                      style: {
                        fontSize: "0.875rem",
                      },
                    },
                  }}
                />
              </div>
            </div>
          </CardContent>
        </Card>
      </main>
      {/* Validation modal and alert box for API results component */}
      <AddProductValMOdal
        validationModal={validationModal}
        closeValidationModal={closeValidationModal}
        handleAlertClose={handleAlertClose}
        alert={alert}
      />
    </Box>
  );
};
export default ContainerDetails;
